import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { PickMatchRecord } from "slotworks/model/gameplay/records/pick-match-record";

export class AgsIsRecoveryPick extends Decision {
    public evaluate(): Exit {
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();
        const isRecovery = gameplay.isRecovered;
        const isInPickBonus = record instanceof PickMatchRecord && !record.complete;
        return isRecovery && isInPickBonus ? Exit.True : Exit.False;
    }
}
